import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

const plans = [
  {
    name: "Free",
    price: "€0",
    period: "forever, per team",
    description: "Great for casual teams that don't mind ads",
    features: [
      "Unlimited players & staff",
      "Scheduling & RSVP",
      "Basic lineup builder",
      "Ad-supported experience",
    ],
    cta: "Get Started",
    featured: false,
  },
  {
    name: "Pro",
    price: "€9",
    period: "/month per team",
    description: "One price covers your whole team — no per-user fees",
    features: [
      "Everything in Free",
      "Ad-free for the entire team",
      "Match results & player stats",
      "Team Chat — real-time messaging",
      "Advanced lineup builder",
      "Email announcements & RSVP reminders",
      "Priority support",
    ],
    cta: "Upgrade your club",
    featured: true,
  },
  {
    name: "Multi-Club",
    price: "from €30",
    period: "/month per club",
    description: "For clubs and academies running multiple teams",
    features: [
      "All Pro features",
      "Ad-free for the entire club",
      "Unlimited teams under one club",
      "File storage for plans, forms & PDFs",
      "Club-wide announcements",
      "Bulk invites",
      "Dedicated onboarding",
    ],
    cta: "Contact Us",
    featured: false,
  },
];

const PricingSection = () => {
  return (
    <section id="pricing" className="py-24 md:py-32 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-4">
            Simple, transparent pricing
          </h2>
          <p className="text-muted-foreground text-lg">
            Start free. Upgrade when you need more.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {plans.map((plan) => (
            <div key={plan.name} className="relative">
              {plan.featured && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-primary text-primary-foreground text-xs font-semibold z-20">
                  Most Popular
                </div>
              )}
              <div className={`h-full rounded-2xl border ${plan.featured ? "bg-navy border-primary/40 text-navy-foreground" : "bg-card border-border/60"}`}>
                <div className="p-8">
                  <h3 className="font-display font-bold text-xl mb-1">{plan.name}</h3>
                  <p className={`text-sm mb-6 ${plan.featured ? "text-navy-foreground/70" : "text-muted-foreground"}`}>
                    {plan.description}
                  </p>

                  <div className="mb-6">
                    <span className="font-display text-4xl font-bold">{plan.price}</span>
                    <span className={`text-sm ${plan.featured ? "text-navy-foreground/70" : "text-muted-foreground"}`}>
                      {plan.period}
                    </span>
                  </div>

                  <ul className="space-y-3 mb-8">
                    {plan.features.map((f) => (
                      <li key={f} className="flex items-center gap-2 text-sm">
                        <Check className="w-4 h-4 flex-shrink-0 text-primary" />
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>

                  <Button
                    variant={plan.featured ? "hero" : "hero-outline"}
                    className="w-full"
                    size="lg"
                    asChild
                  >
                    <Link to="/auth?tab=signup">{plan.cta}</Link>
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
